import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/.jenkins/workspace/47.102.216.211-loffice-frontend-dev/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import router from "./routers";
import store from '@/store';
import Config from '@/settings';
import config from '@/config';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // getToken from cookie
import { buildMenus } from '@/api/system/menu';
import { filterAsyncRouter } from '@/store/modules/permission';
import { Notification } from 'element-ui';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/retrieve', '/resetPass', '/transfer']; // no redirect whitelist

router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + Config.title;
  }
  NProgress.start();
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({
        path: '/'
      });
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(function () {
          // 拉取user_info
          // 动态路由，拉取菜单
          loadMenus(next, to);
        }).catch(function () {
          store.dispatch('LogOut').then(function () {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        });
        // 登录时未拉取 菜单，在此处拉取
      } else if (store.getters.loadMenus) {
        // 修改成false，防止死循环
        store.dispatch('updateLoadMenus');
        loadMenus(next, to);
      } else {
        next();
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next("/login?redirect=".concat(to.fullPath)); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});
export var loadMenus = function loadMenus(next, to) {
  buildMenus().then(function (res) {
    if (res && res.list && res.list.length > 0) {
      console.log("\uD83D\uDC74index 37 res ===>", res);
      var sdata = JSON.parse(JSON.stringify(res.list));
      var rdata = JSON.parse(JSON.stringify(res.list));
      var user = store.getters.user || {};
      var prjIds = Array.isArray(user.prjIdList) ? user.prjIdList : user.employeeInfo && [user.employeeInfo.projectId] || [];
      var allowInterests = Array.isArray(prjIds) && (prjIds.includes(config.ZJPrjId) || prjIds.includes(config.XTPrjId)
      // prjIds.includes(6666) || prjIds.includes(9999)
      );

      var matchInterests = function matchInterests(route) {
        if (!route) return false;
        var t = route.meta && route.meta.title;
        if (['权益管理', '推荐问题管理', '数字客服'].includes(t)) return true;
        var c = route.component;
        return typeof c === 'string' && c.indexOf('interests/') !== -1;
      };
      var filterMenus = function filterMenus(list) {
        return (list || []).filter(function (r) {
          if (!allowInterests && matchInterests(r)) return false;
          if (r.meta && r.meta.title === '生态关系匹配') {
            if (!user.username || user.username.toLowerCase() !== 'root') {
              return false;
            }
          }
          if (r.meta && r.meta.title === '错误日志') {
            if (!user.username || user.username.toLowerCase() !== 'root') {
              return false;
            }
          }
          if (r.children && r.children.length) {
            r.children = filterMenus(r.children);
          }
          return true;
        });
      };
      var sfiltered = filterMenus(sdata);
      var rfiltered = filterMenus(rdata);
      var sidebarRoutes = filterAsyncRouter(sfiltered);
      var rewriteRoutes = filterAsyncRouter(rfiltered, false, true);
      rewriteRoutes.push({
        path: '*',
        redirect: '/404',
        hidden: true
      });
      store.dispatch('GenerateRoutes', rewriteRoutes).then(function () {
        // 存储路由
        router.addRoutes(rewriteRoutes); // 动态添加可访问路由表
        next(_objectSpread(_objectSpread({}, to), {}, {
          replace: true
        }));
      });
      store.dispatch('SetSidebarRouters', sidebarRoutes);
    } else {
      Notification.error({
        title: '菜单获取失败',
        duration: 5000
      });
      store.dispatch('LogOut').then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  });
};

router.afterEach(function () {
  NProgress.done(); // finish progress bar
});